var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    !_vm.isExternal && _vm.href
      ? "router-link-component"
      : "html-link-component",
    {
      tag: "component",
      attrs: {
        href: _vm.href,
        target: _vm.target,
        "active-class": _vm.activeClass,
        "exact-active-class": _vm.exactActiveClass
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b7b72c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b7b72c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/common/Link.vue
// module id = 275
// module chunks = 17